<div>
    <ng-container *ngIf="responseMessage == 'success'" [formGroup]="editArticleForm">
        <div class="row">
            <div class="col-md-8 article-view-padded right-bordered">
                <ubs-edit-blog-article-name [contentName]="contentName" formGroupName="contentNameInfo" (titleSubmit)="onSubmit()" [ofbizForm]="ofbizForm" [fields]="fields"></ubs-edit-blog-article-name>
                <div style="width:inherit;position:relative">
                    <ubs-edit-blog-image [imageUrl]="imageUrl" style="width: inherit;" formGroupName="uploadInfo" (imageSubmit)="onSubmit()" [ofbizForm]="ofbizForm" [fields]="fields"></ubs-edit-blog-image>
                </div>
                <ubs-edit-article-data [articleData]="articleData" formGroupName="articleInfo" (articleSubmit)="onSubmit()" [ofbizForm]="ofbizForm" [fields]="fields"></ubs-edit-article-data>
            </div>
            <div class="col-md-4 article-view-padded">
                <div class="view-section">
                    <ubs-edit-blog-description [description]="description" formGroupName="descriptionInfo" (descriptionSubmit)="onSubmit()"[ofbizForm]="ofbizForm" [fields]="fields"></ubs-edit-blog-description>
                </div>
                <div class="view-section">
                    <ubs-edit-blog-status [statusId]="statusId" formGroupName="statusInfo" (statusSubmit)="onSubmit()" [fields]="fields"></ubs-edit-blog-status>
                </div>
                <div class="view-section">
                    <ubs-edit-summary [summaryData]="summaryData" formGroupName="summaryInfo" (summarySubmit)="onSubmit()" [ofbizForm]="ofbizForm" [fields]="fields"></ubs-edit-summary>
                </div>
            </div>
        </div>
        
    </ng-container>
</div>

